<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
  >
    <g opacity="0.6" clip-path="url(#clip0_263_1941)">
      <mask
        id="mask0_263_1941"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="45"
        height="45"
      >
        <path d="M0 0H44.0004V44.0226H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_263_1941)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M29.8703 0.537539C30.2141 0.193666 30.6803 0.000488281 31.1665 0.000488281C31.6526 0.000488281 32.1188 0.193666 32.4626 0.537539L43.4627 11.5432C43.7967 11.8891 43.9815 12.3525 43.9773 12.8334C43.9731 13.3144 43.7803 13.7744 43.4404 14.1145C43.1005 14.4546 42.6407 14.6475 42.16 14.6517C41.6793 14.6559 41.2161 14.471 40.8704 14.1368L29.8703 3.1312C29.5266 2.78722 29.3335 2.32075 29.3335 1.83437C29.3335 1.34799 29.5266 0.881516 29.8703 0.537539Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M43.4632 0.537442C43.8069 0.881419 44 1.34789 44 1.83427C44 2.32066 43.8069 2.78713 43.4632 3.1311L32.4631 14.1367C32.294 14.3119 32.0917 14.4517 31.868 14.5478C31.6443 14.6439 31.4038 14.6945 31.1603 14.6967C30.9169 14.6988 30.6755 14.6524 30.4502 14.5601C30.2249 14.4679 30.0202 14.3317 29.848 14.1595C29.6759 13.9873 29.5398 13.7825 29.4476 13.557C29.3554 13.3316 29.309 13.0901 29.3111 12.8465C29.3132 12.603 29.3638 12.3623 29.4599 12.1385C29.556 11.9147 29.6957 11.7123 29.8708 11.5431L40.8709 0.537442C41.2147 0.193569 41.6809 0.000391702 42.167 0.000391702C42.6532 0.000391702 43.1194 0.193569 43.4632 0.537442ZM0 18.3427C0 8.15885 8.15474 0 18.3335 0C18.8197 0 19.286 0.193253 19.6299 0.537246C19.9737 0.881239 20.1668 1.34779 20.1668 1.83427C20.1668 2.32075 19.9737 2.78731 19.6299 3.1313C19.286 3.47529 18.8197 3.66855 18.3335 3.66855C10.1788 3.66855 3.6667 10.1839 3.6667 18.3427C3.6667 26.5016 10.1788 33.0169 18.3335 33.0169C24.3395 33.0169 29.5756 29.275 31.8709 24.029C32.075 23.5982 32.4386 23.2637 32.8848 23.0966C33.331 22.9294 33.8248 22.9426 34.2614 23.1334C34.6981 23.3241 35.0434 23.6775 35.2241 24.1186C35.4048 24.5597 35.4068 25.0539 35.2296 25.4964C32.3916 31.9897 25.8942 36.6855 18.3335 36.6855C8.15474 36.6855 0 28.5266 0 18.3427Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28.7707 28.7853C29.1145 28.4415 29.5807 28.2483 30.0668 28.2483C30.553 28.2483 31.0192 28.4415 31.363 28.7853L43.4631 40.8915C43.7971 41.2375 43.9819 41.7008 43.9777 42.1818C43.9735 42.6627 43.7807 43.1228 43.4408 43.4629C43.1009 43.803 42.6411 43.9959 42.1604 44C41.6797 44.0042 41.2165 43.8193 40.8708 43.4852L28.7707 31.379C28.427 31.035 28.2339 30.5686 28.2339 30.0822C28.2339 29.5958 28.427 29.1293 28.7707 28.7853Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_263_1941">
        <rect width="44" height="44" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({})
</script>
